import { makeStyles } from '@mui/styles';
import { useEffect, useRef } from 'react';

const useStyles = makeStyles({
  root: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    backgroundColor: 'black',
    objectFit: 'cover',
    zIndex: 3,
    transform: 'scaleX(-1)'
  }
});

export default function CameraPreview({ selectedCamera, setCameraGranted }) {
  const classes = useStyles();
  const mediaStreamRef = useRef<MediaStream | null>(null);

  useEffect(() => {
    const getMedia = async () => {
      try {
        const mediaStream = await navigator.mediaDevices.getUserMedia({
          video: { deviceId: selectedCamera }
        });
        mediaStreamRef.current = mediaStream;

        const video = document.querySelector('#cameraPreview') as HTMLVideoElement;
        if (!video) {
          return;
        }
        video.srcObject = mediaStream;
        video.onloadedmetadata = () => {
          video.play();
        };
        setCameraGranted(true);
      } catch (error: any) {
        console.error(error?.name, ':', error?.message);
        if (error?.name === 'NotAllowedError' || error?.name === 'NotFoundError') {
          setCameraGranted(false);
        }
      }
    };

    getMedia();

    return () => {
      mediaStreamRef.current?.getTracks()?.forEach((track) => {
        track.stop();
      });
    };
  }, [selectedCamera, setCameraGranted]);

  return <video id="cameraPreview" className={classes.root} />;
}
